import { render, staticRenderFns } from "./migracion.vue?vue&type=template&id=3f7b66eb&scoped=true"
import script from "./migracion.vue?vue&type=script&lang=js"
export * from "./migracion.vue?vue&type=script&lang=js"
import style0 from "./migracion.vue?vue&type=style&index=0&id=3f7b66eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b66eb",
  null
  
)

export default component.exports